import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PageHeader from './PageHeader';
import AxiosPost from '../http/Axios';

const AddChild = (props) => {
  const [childData, setChildData] = useState({
    additionalLanguage1: '',
    additionalLanguage2: '',
    familyEmail: '',
    firstName: '',
    gender: '',
    languageSpokenAtHome: 'English',
    monthOfBirth: '',
    whichHandId: 'Right-handed',
    yearOfBirth: '',
  });

  // Define month to number mapping
  const monthNameToNumber = {
    January: '01',
    February: '02',
    March: '03',
    April: '04',
    May: '05',
    June: '06',
    July: '07',
    August: '08',
    September: '09',
    October: '10',
    November: '11',
    December: '12',
  };

  const numericMonthOfBirth =
    monthNameToNumber[childData.monthOfBirth] || childData.monthOfBirth;

  const location = useLocation();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});

  const queryParams = new URLSearchParams(location.search);
  const guid = queryParams.get('guid');
  const familyEmail = queryParams.get('familyEmail');
  const familyName = queryParams.get('familyName');
  const loggedInAs = sessionStorage.getItem("loggedInAs") || "admin";

  useEffect(() => {
    setChildData((prevData) => ({
      ...prevData,
      familyEmail: familyEmail || '',
    }));
  }, [familyEmail]);

  useEffect(() => {
    document.title = 'LeapFrog Lab Registration Admin Portal';
  }, []);

  const generateYearOptions = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 11 }, (_, i) => (
      <option key={i} value={currentYear - i}>
        {currentYear - i}
      </option>
    ));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const childPostData = {
      email: familyEmail,
      firstName: childData.firstName,
      gender: childData.gender,
      monthOfBirth: numericMonthOfBirth,
      yearOfBirth: childData.yearOfBirth,
      whichHandId: childData.whichHandId,
      languageSpokenAtHome: childData.languageSpokenAtHome,
      additionalLanguage1: childData.additionalLanguage1,
      additionalLanguage2: childData.additionalLanguage2,
      registeredIndicator: 'Y',
      registeredDate: new Date(),
      disabledIndicator: 'N',
      createdDate: new Date(),
      createdBy: loggedInAs,
      modifiedDate: new Date(),
      modifiedBy: loggedInAs,
    };

    console.log(childPostData);

    try {
      const response = await AxiosPost(
        process.env.REACT_APP_ADMIN_SERVICE + '/children',
        childPostData
      );
      console.log('Child data submitted successfully:', response.data);

      const familyDetailsPath = '/family-details-page';

      navigate(
        `${familyDetailsPath}?guid=${guid}`
      );
    } catch (error) {
      console.error('Error submitting child data:', error);
    }
  };

  const handleCancel = () => {
    const familyDetailsPath = '/family-details-page';

    navigate(
      `${familyDetailsPath}?guid=${guid}`
    );
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setChildData((prevData) => ({ ...prevData, [name]: value }));
  };

  return (
    <div className="dashboard landing-page">
      <PageHeader title={familyName ? `The ${familyName} Family: Add Child` : "Add Child"} />

      <main className="page-content">
        <div>
          <form onSubmit={handleSubmit}>
            <div className="child-section">
              <br />
              <br />
              <div className="child-input-grid">

                <div className="child-input-group">
                  <label htmlFor="firstName">
                    Child's first name <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    value={childData.firstName}
                    onChange={handleInputChange}
                    required
                    maxLength="31"
                    pattern="[a-zA-Z .'-]+"
                    className="child-input-size"
                  />
                  {errors.firstName && (
                    <p className="error-message">{errors.firstName}</p>
                  )}
                </div>

                <div className="child-input-group">
                  <label htmlFor="gender">
                    Gender <span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    name="gender"
                    value={childData.gender}
                    onChange={handleInputChange}
                    required
                    className="child-input-size"
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                    <option value="Decline to state">Decline to state</option>
                  </select>
                  {errors.gender && (
                    <p className="error-message">{errors.gender}</p>
                  )}
                </div>

                <div className="child-input-group">
                  <label>
                    Date of birth <span style={{ color: 'red' }}>*</span>
                  </label>
                  <div className="dob-container">
                    <select
                      name="monthOfBirth"
                      value={childData.monthOfBirth}
                      onChange={handleInputChange}
                      required
                      className="child-birth-input-size"
                    >
                      <option value="">Select Month</option>
                      {[
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December',
                      ].map((month, index) => (
                        <option key={index} value={month}>
                          {month}
                        </option>
                      ))}
                    </select>
                    {errors.monthOfBirth && (
                      <p className="error-message">{errors.monthOfBirth}</p>
                    )}

                    <select
                      name="yearOfBirth"
                      value={childData.yearOfBirth}
                      onChange={handleInputChange}
                      required
                      className="child-birth-input-size"
                    >
                      <option value="">Select Year</option>
                      {generateYearOptions()}
                    </select>
                    {errors.yearOfBirth && (
                      <p className="error-message">{errors.yearOfBirth}</p>
                    )}
                  </div>
                </div>

                <div className="child-input-group">
                  <label htmlFor="whichHandId">
                    Which hand? <span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    name="whichHandId"
                    value={childData.whichHandId}
                    onChange={handleInputChange}
                    required
                    className="child-input-size"
                  >
                    <option value="">Select Preference</option>
                    <option value="Right-handed">Right-handed</option>
                    <option value="Left-handed">Left-handed</option>
                    <option value="Ambidextrous">Ambidextrous</option>
                    <option value="Don’t know">Don’t know</option>
                  </select>
                  {errors.whichHandId && (
                    <p className="error-message">{errors.whichHandId}</p>
                  )}
                </div>

                <div className="child-input-group">
                  <label htmlFor="languageSpokenAtHome">
                    Language spoken at home{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    name="languageSpokenAtHome"
                    value={childData.languageSpokenAtHome}
                    onChange={handleInputChange}
                    required
                    className="child-input-size"
                  >
                    <option value="English">English</option>
                    <option value="Spanish">Spanish</option>
                    <option value="French">French</option>
                    <option value="German">German</option>
                    <option value="Italian">Italian</option>
                    <option value="Greek">Greek</option>
                    <option value="Chinese (Mandarin)">
                      Chinese (Mandarin)
                    </option>
                    <option value="Chinese (Cantonese)">
                      Chinese (Cantonese)
                    </option>
                    <option value="Taiwanese">Taiwanese</option>
                    <option value="Japanese">Japanese</option>
                    <option value="Korean">Korean</option>
                    <option value="ASL">ASL</option>
                    <option value="Tagalog">Tagalog</option>
                    <option value="Telugo">Telugo</option>
                    <option value="Hebrew">Hebrew</option>
                    <option value="Filipino">Filipino</option>
                    <option value="Urdu">Urdu</option>
                    <option value="Russian">Russian</option>
                    <option value="Serbian">Serbian</option>
                    <option value="Portuguese">Portuguese</option>
                    <option value="Armenian">Armenian</option>
                    <option value="Hungarian">Hungarian</option>
                    <option value="Slovak">Slovak</option>
                    <option value="Romanian">Romanian</option>
                    <option value="Other">Other</option>
                  </select>
                  {errors.languageSpokenAtHome && (
                    <p className="error-message">
                      {errors.languageSpokenAtHome}
                    </p>
                  )}
                </div>

                <div className="child-input-group">
                  <label htmlFor="additionalLanguage1">
                    Additional Language 1{' '}
                  </label>
                  <select
                    name="additionalLanguage1"
                    value={childData.additionalLanguage1}
                    onChange={handleInputChange}
                    className="child-input-size"
                  >
                    <option value="">Select Language</option>
                    <option value="English">English</option>
                    <option value="Spanish">Spanish</option>
                    <option value="French">French</option>
                    <option value="German">German</option>
                    <option value="Italian">Italian</option>
                    <option value="Greek">Greek</option>
                    <option value="Chinese (Mandarin)">
                      Chinese (Mandarin)
                    </option>
                    <option value="Chinese (Cantonese)">
                      Chinese (Cantonese)
                    </option>
                    <option value="Taiwanese">Taiwanese</option>
                    <option value="Japanese">Japanese</option>
                    <option value="Korean">Korean</option>
                    <option value="ASL">ASL</option>
                    <option value="Tagalog">Tagalog</option>
                    <option value="Telugo">Telugo</option>
                    <option value="Hebrew">Hebrew</option>
                    <option value="Filipino">Filipino</option>
                    <option value="Urdu">Urdu</option>
                    <option value="Russian">Russian</option>
                    <option value="Serbian">Serbian</option>
                    <option value="Portuguese">Portuguese</option>
                    <option value="Armenian">Armenian</option>
                    <option value="Hungarian">Hungarian</option>
                    <option value="Slovak">Slovak</option>
                    <option value="Romanian">Romanian</option>
                    <option value="Other">Other</option>
                  </select>
                  {errors.additionalLanguage1 && (
                    <p className="error-message">
                      {errors.additionalLanguage1}
                    </p>
                  )}
                </div>

                <div className="child-input-group">
                  <label htmlFor="additionalLanguage2">
                    Additional Language 2{' '}
                  </label>
                  <select
                    name="additionalLanguage2"
                    value={childData.additionalLanguage2}
                    onChange={handleInputChange}
                    className="child-input-size"
                  >
                    <option value="">Select Language</option>
                    <option value="English">English</option>
                    <option value="Spanish">Spanish</option>
                    <option value="French">French</option>
                    <option value="German">German</option>
                    <option value="Italian">Italian</option>
                    <option value="Greek">Greek</option>
                    <option value="Chinese (Mandarin)">
                      Chinese (Mandarin)
                    </option>
                    <option value="Chinese (Cantonese)">
                      Chinese (Cantonese)
                    </option>
                    <option value="Taiwanese">Taiwanese</option>
                    <option value="Japanese">Japanese</option>
                    <option value="Korean">Korean</option>
                    <option value="ASL">ASL</option>
                    <option value="Tagalog">Tagalog</option>
                    <option value="Telugo">Telugo</option>
                    <option value="Hebrew">Hebrew</option>
                    <option value="Filipino">Filipino</option>
                    <option value="Urdu">Urdu</option>
                    <option value="Russian">Russian</option>
                    <option value="Serbian">Serbian</option>
                    <option value="Portuguese">Portuguese</option>
                    <option value="Armenian">Armenian</option>
                    <option value="Hungarian">Hungarian</option>
                    <option value="Slovak">Slovak</option>
                    <option value="Romanian">Romanian</option>
                    <option value="Other">Other</option>
                  </select>
                  {errors.additionalLanguage2 && (
                    <p className="error-message">
                      {errors.additionalLanguage2}
                    </p>
                  )}
                </div>

                <div className="button-group">
                  <button type="submit" className="submit-button">
                    Submit
                  </button>
                  <button
                    type="button"
                    className="cancel-button"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default AddChild;
